export default "__VITE_ASSET__BXH1r0rw__"